import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

export default class extends PureComponent {

  static displayName = 'ChannelItemBase';

  static propTypes = {
    isLast: PropTypes.bool.isRequired,
  }

  componentDidMount() {
    const { isLast } = this.props;
    if (isLast) {
      /*eslint-disable react/no-find-dom-node*/
      const targetDomNode = ReactDOM.findDOMNode(this);
      /*eslint-enable react/no-find-dom-node*/
      targetDomNode.parentNode.scrollTop = targetDomNode.offsetTop - targetDomNode.parentNode.offsetTop;
    }
  }
}
